import React from "react";
export default function ExcerciseComponent() {
  return <h4>Hướng dẫn tải tài liệu bổ trợ</h4>;
}
